import React, { useMemo } from 'react';
import { BaseEdge, EdgeProps, getSimpleBezierPath } from 'reactflow';
import { EdgeData } from './types';
import { transitionFunc } from '../../theme/utils';

const DEFAULT_WIDTH = 2;
const DEFAULT_COLOR = 'rgba(13, 197, 179, 0.23)';
const DEFAULT_HIGHLIGHT_COLOR = 'rgba(13, 197, 179, 0.80)';

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: EdgeProps<EdgeData>) {
  const strokeWidth = Math.max(data?.height || DEFAULT_WIDTH, DEFAULT_WIDTH);
  const stroke = useMemo(() => {
    if (data?.highlight) return data.highlightColor || DEFAULT_HIGHLIGHT_COLOR;

    return data?.color || DEFAULT_COLOR;
  }, [data?.color, data?.highlight]);

  if (data?.recursive) {
    return (
      <g transform={`translate(${targetX}, ${targetY})`}>
        <path
          d="M177 63.6909V42C177 29.8497 167.15 20 155 20H42.1739C29.9559 20 20.0784 29.9556 20.1746 42.1732L20.3281 61.6732C20.4233 73.7555 30.2448 83.5 42.3275 83.5H83.6098"
          stroke={stroke}
          strokeWidth={strokeWidth}
          fill="none"
          transform={`translate(-60, -85)`}
        />
      </g>
    );
  }

  const strokeOpacity = data?.highlight === false ? 0.5 : 1;
  const transition = `stroke-opacity 0.4s ${transitionFunc}`;

  const [edgePath] = getSimpleBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const baseEdge = (
    <BaseEdge
      id={id}
      path={edgePath}
      style={{ stroke, strokeWidth, strokeOpacity, transition }}
    />
  );

  return baseEdge;
}
